import * as React from 'react';

import * as UI from 'core/ui';
import * as Images from 'pos/Images';

import { Command } from 'pos/common';
import { Preconditions } from 'core/infrastructure-next';
import { Permission, PrintPreviewDTO, PrintTemplateType, Res } from 'core/api';
import { PrintFacade } from 'pos/facades';
import { PrintBalanceNextAction } from 'pos/modules/helpers/PrintBalanceNextAction';
import { Modal } from 'core/ui-next/modal';
import { BackActionButton, Content, Filler, Footer, Header, PhoneDeviceActionButton, PhoneOnly, PosScreen } from 'pos/ui';
import { Box, VStack } from '@chakra-ui/react';

type Props = {
	systemCloseOutPreview: PrintPreviewDTO;
} & Modal.Actions<PrintBalanceNextAction>;

function ShowSystemStatusScreen(props: Props) {
	const { systemCloseOutPreview, cancel, close } = props;

	const printSystemStatus = async (): Promise<void> => {

		const printResult = await Command.execute('printSystemStatus');
		if (!printResult.ok)
			return;

		if (printResult.value === PrintBalanceNextAction.CloseDay)
			close(printResult.value);
	};

	const showPointOfSaleStatus = async (): Promise<void> => {
		const result = await Command.execute('showPointsOfSaleStatus');
		if (!result.ok)
			return;

		if (result.value === PrintBalanceNextAction.CloseDay)
			return close(result.value);
	};

	const onCancel = React.useCallback(async () => cancel(), [cancel]);

	return (
		<PosScreen screenId={'SYSTEM_STATUS'} size={'small'} useKeyPad={false}>
			<Header title={Res.Web.SHOW_SYSTEM_STATUS()} onClose={cancel} />
			<Content>
				<VStack width={'full'} height={'full'} padding={'4'}>
					<Box padding={'2'} border={'1px solid #ccc'} overflow={'auto'} width={'full'}>
						<UI.TemplatePrintPreview preview={systemCloseOutPreview} />
					</Box>
				</VStack>
			</Content>
			<Footer>
				<PhoneOnly>
					<BackActionButton action={onCancel} />
				</PhoneOnly>
				<Filler />
				<PhoneDeviceActionButton title={Res.Web.SHOW_SYSTEM_STATUS_POINT_OF_SALE_BTN()} image={Images.PointOfSaleStatus} action={showPointOfSaleStatus} />
				<PhoneDeviceActionButton title={Res.Web.SHOW_SYSTEM_STATUS_PRINT_BTN()} image={Images.PrintTicket} action={printSystemStatus} />
			</Footer>
		</PosScreen>
	);
}

declare global {
	interface CommandType {
		showSystemStatus: () => Promise<Result<PrintBalanceNextAction>>
	}
}

Command.register('showSystemStatus', Preconditions.ensure(Permission.System_ShowStatus), async (): Promise<Result<PrintBalanceNextAction>> => {
	const preview: PrintPreviewDTO = {
		EscPosPreview: await PrintFacade.getSystemCloseOutReportPreview(),
		EscPosNumberOfColumns: 0,
		RdlBase64Images: [],
		TemplateType: PrintTemplateType.EscPos
	};

	return await Modal.show(ShowSystemStatusScreen, { systemCloseOutPreview: preview });
});